import React from 'react'
import { Circle, ContentLoader, Rect } from '@src/components/ContentLoader'
import { StyleService, useStyleSheet } from '@src/style/service'

export const ActionGoalSummaryLoadingCard = () => {
  const styles = useStyleSheet(themedStyles)
  return (
    <ContentLoader variant="card" style={styles.loadingContainer}>
      <Rect x="72" y="16" width="36%" height="16" rx="2" ry="4" />
      <Rect x="72" y="46" width="70%" height="16" rx="2" ry="4" />
      <Circle cx="35" cy="35" r="24" strokeWidth="2.5" />
      {Array.from({ length: 7 }).map((_, i) => (
        // Completion circle for each day of the week
        <Circle
          key={i}
          cx={86 + i * (10 + 26)} // 10px radius + 26px space
          cy={80}
          r={10}
          strokeWidth="1"
        />
      ))}
    </ContentLoader>
  )
}

const themedStyles = StyleService.create({
  loadingContainer: {
    flex: 1,
    borderWidth: 2,
    borderColor: 'theme.surface.base2',
    borderRadius: 12,
    paddingTop: 24,
  },
})
